(function () {
  'use strict';

  // Prevent the boot logic running twice on pages that include this script
  // from both the home-page section and the header-drawer snippet.
  if (window.__rvBooted) return;
  window.__rvBooted = true;

  var STORAGE_KEY = 'oyela_recently_viewed';

  function getStored() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  // ── Format money (cents → display string) ────────────────────────────────
  function formatMoney(cents, format) {
    var amount = (parseInt(cents, 10) / 100).toFixed(2);
    var noDecimals = String(Math.round(parseInt(cents, 10) / 100));
    return (format || '{{ amount }}')
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // ── Build a single product card reusing the theme's card CSS ─────────────
  function buildCard(p, moneyFormat) {
    var hasCompare = p.compare_at_price && parseInt(p.compare_at_price, 10) > parseInt(p.price, 10);

    var priceHtml = hasCompare
      ? '<div class="price price--on-sale"><div class="price__container">' +
          '<span class="price-item price-item--sale">' + formatMoney(p.price, moneyFormat) + '</span>' +
          '<span class="price-item price-item--regular"><s class="price-item--compare">' + formatMoney(p.compare_at_price, moneyFormat) + '</s></span>' +
        '</div></div>'
      : '<div class="price"><div class="price__container">' +
          '<span class="price-item price-item--regular">' + formatMoney(p.price, moneyFormat) + '</span>' +
        '</div></div>';

    var soldOutOverlay = p.available === false
      ? '<div class="card__content custom-out-of-stock-overlay"><div class="custom-sold-out-text">Sold Out</div></div>'
      : '';

    var hoverImg = p.image_hover
      ? '<img src="' + escapeHtml(p.image_hover) + '" alt="" class="motion-reduce" loading="lazy" width="533" height="666">'
      : '';

    return '<div class="rv-carousel__item">' +
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
        '<div class="card card--standard card--media" style="--ratio-percent:125%;">' +
          '<div class="card__inner color-background-1 gradient ratio" style="--ratio-percent:125%;">' +
            '<div class="card__media">' +
              '<div class="media media--transparent media--hover-effect">' +
                '<img src="' + escapeHtml(p.image) + '" alt="' + escapeHtml(p.title) + '" class="motion-reduce" loading="lazy" width="533" height="666">' +
                hoverImg +
              '</div>' +
            '</div>' +
            soldOutOverlay +
          '</div>' +
          '<div class="card__content">' +
            '<div class="card__information">' +
              '<h3 class="card__heading h5">' +
                '<a href="' + escapeHtml(p.url) + '" class="full-unstyled-link">' + escapeHtml(p.title) + '</a>' +
              '</h3>' +
              '<div class="card-information">' + priceHtml + '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  // ── Render carousel into a single section element ────────────────────────
  function renderSection(section, products) {
    if (section.hasAttribute('data-rv-rendered')) return;
    section.setAttribute('data-rv-rendered', '1');

    var track = section.querySelector('.rv-carousel__track');
    if (!track) return;

    var max = parseInt(section.dataset.maxProducts || '10', 10);
    var moneyFormat = section.dataset.moneyFormat || '{{ amount }}';
    var display = products.slice(0, max);

    if (display.length === 0) {
      section.style.display = 'none';
      return;
    }

    track.innerHTML = display.map(function (p) { return buildCard(p, moneyFormat); }).join('');
    section.style.display = '';

    setupArrows(section);
  }

  // ── Render carousel into all .rv-section instances ────────────────────────
  function renderCarousel() {
    var sections = document.querySelectorAll('.rv-section');
    if (!sections.length) return;

    var products = getStored();
    sections.forEach(function (section) {
      renderSection(section, products);
    });
  }

  function setupArrows(section) {
    var viewport = section.querySelector('.rv-carousel__viewport');
    var prevBtn = section.querySelector('.rv-carousel__prev');
    var nextBtn = section.querySelector('.rv-carousel__next');
    if (!viewport || !prevBtn || !nextBtn) return;

    function scrollAmount() { return viewport.offsetWidth * 0.85; }

    prevBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: -scrollAmount(), behavior: 'smooth' });
    });
    nextBtn.addEventListener('click', function () {
      viewport.scrollBy({ left: scrollAmount(), behavior: 'smooth' });
    });

    function updateArrows() {
      var atStart = viewport.scrollLeft <= 1;
      var atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
      prevBtn.style.opacity = atStart ? '0.35' : '1';
      nextBtn.style.opacity = atEnd ? '0.35' : '1';
    }

    viewport.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  // ── Boot ─────────────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderCarousel);
  } else {
    renderCarousel();
  }
})();
